module.exports = __webpack_public_path__ + "static/ascend-db38d5913499af1ab437451b812b42ab.jpg";